import CardDetailsHeader from './CardDetailsHeader';

export default CardDetailsHeader;